import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Unified read-only boolean indicator for admin lists and detail cards.
 *
 * Presents a plain true/false fact with a single, consistent visual language:
 *  - true  → filled check, success green
 *  - false → neutral dash, muted grey (NOT an error/danger colour)
 *
 * Use `label` for checklist-style rows (icon + text); omit it for dense table
 * cells (icon only). The Yes/No meaning is always exposed via tooltip and
 * aria-label so it never relies on colour alone.
 */
@Component({
  selector: 'app-bool',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatTooltipModule, TranslatePipe],
  templateUrl: './bool.component.html',
})
export class BoolComponent {
  /** The boolean fact to display. Null/undefined are treated as false. */
  readonly value = input.required<boolean | null | undefined>();

  /** Optional already-translated label rendered next to the icon (checklist style). */
  readonly label = input<string | null>(null);
}
